"use strict";
if (!globalThis.navigator) {
    globalThis.navigator = {};
}
//# sourceMappingURL=handle-DOM-absence.js.map